import styled from 'styled-components';
import { MediaImage } from '@elfsight/widget-media';
import { getInvertedColor } from '@elfsight/widget-utils';
import tinycolor from 'tinycolor2';
import { useLocationCardProps } from './location-card-settings-context';

interface BusinessLogoImageProps {
  style?: 'default' | 'overlap';
  color?: string;
}

export function BusinessLogoImage({
  style = 'default',
  color
}: BusinessLogoImageProps) {
  const { businessLogo, businessLogoSize, businessName } =
    useLocationCardProps();

  const finalColor = color || '#fff';
  const altValue = `Logo of ${businessName}`;

  if (!businessLogo) return null;

  if (style === 'overlap') {
    return (
      <OverlapLogoContainer _size={businessLogoSize} _color={finalColor}>
        <OverlapLogo
          src={businessLogo.url}
          mode="contain"
          alt={altValue}
          _color={finalColor}
        />
      </OverlapLogoContainer>
    );
  }

  return (
    <DefaultLogo
      src={businessLogo.url}
      containerWidth={`${businessLogoSize}px`}
      alt={altValue}
    />
  );
}

const OverlapLogoContainer = styled.div<{ _size: number; _color: string }>`
  z-index: 100000000;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid ${({ _color }) => _color};
  background: ${({ _color }) => _color};
  border-radius: 100%;
  width: ${({ _size }) => _size}px;
  height: ${({ _size }) => _size}px;
`;

const OverlapLogo = styled(MediaImage)<{ _color: string }>`
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 100%;
  border: 1px solid
    ${({ _color }) =>
      tinycolor(getInvertedColor(_color)).setAlpha(0.1).toString()};
`;

const DefaultLogo = styled(MediaImage)`
  display: inline-flex;
`;
